<template>
  <div class="d-inline" v-if="visible">
    <slot></slot>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import config from "@/app/config";

const visible = ref(!config.IS_PRODUCTION);
</script>

<style lang="scss" scoped>

</style>